import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      d: "M9.005 14.067c.26 0 .518-.103.695-.3l8.02-8.218a.92.92 0 0 0 .28-.663.93.93 0 0 0-.943-.953.98.98 0 0 0-.674.269l-7.937 8.114h1.108L1.617 4.202a.95.95 0 0 0-.674-.27.93.93 0 0 0-.943.954c0 .26.104.487.28.674l8.02 8.207c.197.197.436.3.705.3"
    }, null, -1)
  ])))
}
export default { render: render }